import * as React from "react";
import * as Redux from "redux";
import { Provider, connect, batch } from "react-redux";

import store from "./store";

import {
  getListFromStore,
  setEndpoint,
  readListPage,
  reloadList,
  resetListPages,
  addListFilter,
  removeListFilter,
  setListSearch,
  resetListSearch,
  setListSort,
  resetListSort,
  setListSelected,
  resetListSelected,
  addListSelected,
  removeListSelected,
  setListItemsPerPage,
  setListHistoryKeyValues,
} from "../reducers/list";

const mapStateToProps = <ListId extends string, Item extends {id: number}>(listID: ListId) => (state: GlobalStore, ownProps: {}) => (
  getListFromStore<Item>(state, listID)
);

const mapDispatchToProps = <ListId extends string, Item extends {id: number}>(listID: ListId) => (dispatch: Redux.Dispatch, ownProps: {}) => {
  return {
    mountList: (endpoint: string) => batch(() => {
      dispatch(setEndpoint(listID, endpoint));
      dispatch(readListPage(listID) as unknown as Redux.AnyAction); // TODO: FIX
    }),
    setEndpoint: (endpoint: string) => dispatch(setEndpoint(listID, endpoint)),
    readListPage: () => dispatch(readListPage(listID) as unknown as Redux.AnyAction), // TODO: FIX
    reloadList: () => dispatch(reloadList(listID) as unknown as Redux.AnyAction), // TODO: Fix
    resetListPages: () => dispatch(resetListPages(listID)),
    addListFilter: (filterID: string, filter: Filter) => dispatch(addListFilter(listID, filterID, filter)),
    removeListFilter: (filterID: string) => dispatch(removeListFilter(listID, filterID)),
    setListSearch: (search: string) => dispatch(setListSearch(listID, search)),
    resetListSearch: () => dispatch(resetListSearch(listID)),
    setListSort: (sort_by: keyof Item, sort_order: SortOrder) => dispatch(setListSort(listID, sort_by, sort_order)),
    resetListSort: () => dispatch(resetListSort(listID)),
    setListSelected: (selected: Array<Item>) => dispatch(setListSelected(listID, selected)),
    resetListSelected: () => dispatch(resetListSelected(listID)),
    addListSelected: (addSelectedItems: Array<Item>) => dispatch(addListSelected(listID, addSelectedItems)),
    removeListSelected: (removeSelectedItems: Array<Item>) => dispatch(removeListSelected(listID, removeSelectedItems)),
    setListItemsPerPage: (itemsPerPage: number) => dispatch(setListItemsPerPage(listID, itemsPerPage)),
    setListHistoryKeyValues: (keyValues: Partial<ListState<Item>>) => dispatch(setListHistoryKeyValues(listID, keyValues)),
  };
};

export type ListProps<ListId extends string, Item extends {id: number}> = ReturnType<ReturnType<typeof mapStateToProps<ListId, Item>>> & ReturnType<ReturnType<typeof mapDispatchToProps<ListId, Item>>>;

const mergeProps = <ListId extends string, Item extends {id: number}>(listID: ListId) => (stateProps: ReturnType<ReturnType<typeof mapStateToProps<ListId, Item>>>, dispatchProps: ReturnType<ReturnType<typeof mapDispatchToProps<ListId, Item>>>, ownProps: {}) => {
  return {
    [listID]: {
      ...stateProps,
      ...dispatchProps,
    },
    ...ownProps,
  };
};

export default function connectToList<ComponentProps extends object>(component: React.FC<ComponentProps>, possibleListIDs: Array<string> | string) : React.FC<ComponentProps> { // TODO: Should be React.FC<ComponentProps> with Omit for possibleListIDs
  const ConnectedToListComponent = connectToListWithProvider(component, possibleListIDs);

  return (props: {}) => {
    return (
      <Provider store={store()}>
        <ConnectedToListComponent {...props}/>
      </Provider>
    );
  };
}

export function connectToListWithProvider<ListId extends string, Item extends {id: number}>(component: any, possibleListIDs: Array<ListId> | ListId) {
  const listIDs = Array.isArray(possibleListIDs) ? possibleListIDs : [possibleListIDs];

  let ConnectedToListComponent = component;
  listIDs.forEach((listID) => {
    ConnectedToListComponent = connect(mapStateToProps<ListId, Item>(listID), mapDispatchToProps<ListId, Item>(listID), mergeProps<ListId, Item>(listID))(ConnectedToListComponent);
  });

  return ConnectedToListComponent;
}
